import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, ErrorTemplate, ErrorTemplateCode } from 'web-library';
import ErrorPageTitle from '../../../components/errors/ErrorPageTitle';

const NoAccessContent = () => {
  const { t } = useTranslation();

  return (
    <ContentTemplate type="full">
      <ErrorTemplate
        errorCode={'generic' as ErrorTemplateCode}
        title={
          <ErrorPageTitle
            label={t(
              'components->>GenericError.We’re sorry, but you do not have access to this feature.'
            )}
          />
        }
        subtitle=""
      />
    </ContentTemplate>
  );
};

export default NoAccessContent;
